import { Breakpoint, isCompact } from '../types';
import { smallDrawerWidth } from '../../constants';

export const getSidebarWidth = (breakpoint: Breakpoint) => {
    const smallDrawerWidthPx = smallDrawerWidth + 'px';
    if (!isCompact(breakpoint)) {
        return smallDrawerWidthPx;
    } else return '0px';
};
